const is = require('../plugins/helper/is')
const { listen } = require('../plugins/event/listen')
const Swal = require('../plugins/sweet/Alert').default

const defaultSwal = {
  toast: true,
  timer: 2000,
  position: 'top-start',
  showConfirmButton: false,
  timerProgressBar: false,
}

listen('#form-train-chatbase button[type="submit"]', 'click', async function (e) {
  e.preventDefault()

  const trigger = e.delegateTarget || e.currentTarget
  trigger.disabled = true
  const span = is.make('span', { class: 'spinner-border spinner-border-sm' })
  trigger.appendChild(span)
  const form = is.getNode('#form-train-chatbase')
  const formData = new FormData(form)
  const promise = Swal.axiosPost(formData, is.getUniqueAttribute(form, 'action'))
  promise.then(response => {
    Swal.handleResult(true, { data: response.data ?? null, trigger }, 'success-send-data-train-chatbase')

    return response
  }).catch(error => {
    Swal.handleResult(false, { error, trigger }, 'error-send-data-train-chatbase')

    return error
  })

  return false
})
// Listeners
Swal.handleOn('success-send-data-train-chatbase', function (e) {
  const { params } = e
  const form = is.getNode('#form-train-chatbase')
  const Toast = Swal.mixin(defaultSwal)
  const message = 'Datos enviados correctamente.'
  Toast.fire({
    icon: 'success',
    title: message,
  })
  params.trigger.innerHTML = is.getHasAttribute(params.trigger, 'text-submit') ? is.getAttributeValue(params.trigger, 'text-submit') : 'Entrenar chat'
  is.waitInAWhile(defaultSwal.timer).then(() => {
    params.trigger.disabled = false
    window.location.href = is.getUniqueAttribute(form, 'action')
  })
})
Swal.handleOn('error-send-data-train-chatbase', function (e) {
  const { params } = e
  is.captureException(params.error)
  const Toast = Swal.mixin(defaultSwal)
  Toast.fire({
    icon: 'error',
    title: 'Error al entrenar el chat.',
  })
  params.trigger.disabled = false
  params.trigger.innerHTML = is.getHasAttribute(params.trigger, 'text-submit') ? is.getAttributeValue(params.trigger, 'text-submit') : 'Entrenar chat'
})
